<template>
  <div class="container">
    <v-suburb v-show="ifSuburb" @change="changeSuburb" @close="suburbClose()"></v-suburb>
    <v-datepicker v-show="ifDatepk" @change="changeDate" @close="datePickClose()"></v-datepicker>
    <v-cleanprice v-show="ifPrice" @close="priceClose()" :type="data.type_id"></v-cleanprice>
    <div class="main" v-show="!ifSuburb && !ifDatepk && !ifPrice ">
        <div class="navi">
            <span class="close"><span class="icon-arrow-left" @click="goBack()"></span></span>
            <div class="top-title">清洁服务</div>
            <span></span>
        </div>
        <div class="logo"><img src="../../assets/img/index/logohf.svg"></div>
        <div class="core">
            <h2>预定清洁服务</h2>
            <div v-show="nextStep">
                    <img class="prepay-img" src='../../assets/img/other/prepay-amount.png'>
                <div class="weui-cells__title">联系信息</div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">联系人</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="请输入您的名字" v-model="data.member_name"> 
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd">
                            <label class="weui-label">联系手机</label>
                        </div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="tel" placeholder="请输入您的手机号" v-model="data.member_phone">
                        </div>
                    </div>
                </div>
                <div class="notice-yellow form">
                下单后将进入定金支付流程，完成后客服会向您致电确认订单
                </div>
                <br>
            </div>
            <div v-show="!nextStep">
                <div class="weui-cells__title" >服务详情</div>
                <div class="weui-cells weui-cells_form" >
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">服务类型</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select2" v-model="data.type_id">
                                <option value="" selected disabled>点击选择</option>
                                <option value="1550735948" >大扫除清洁</option>
                                <option value="1550735962" >专项清洁</option>
                                <option value="1550735961" >短租屋清洁</option>
                                <option value="1550735971" >周期清洁</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_access padding-fix" @click="datePick()">
                        <div class="weui-cell__hd" v-if="data.type_id==1550735971"><label for="" class="weui-label">初次服务日</label></div>
                        <div class="weui-cell__hd" v-else><label for="" class="weui-label">服务日期</label></div>
                        <div class="weui-cell__bd" v-if="data.service_date==''"> 
                            <p class="placeholder-color">请选择服务日期</p>
                        </div>
                        <div class="weui-cell__bd" v-if="data.service_date!=''"> 
                            <p>{{data.service_date | moment("YYYY年M月D日")}}</p>
                        </div>
                        <div class="weui-cell__ft"></div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label" >服务时间</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select2" v-model="data.service_period">
                                <option value="" selected disabled>点击选择</option>
                                <option value="am" >上午</option>
                                <option value="pm" >下午</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title" >房屋详情</div>
                <div class="weui-cells weui-cells_form" >
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">房屋类型</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select3" v-model="data.house_type">
                                <option value="" selected disabled>点击选择</option>
                                <option value="1552109724">Apartment</option>
                                <option value="1552109729">Unit</option>
                                <option value="1552109735">House</option>
                                <option value="1552109742">Town House</option>
                                <option value="1558079273">Studio</option>
                                <option value="1552109747">Other</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after" v-if="data.type_id!=1550735962">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">清洁范围</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select4" v-model="data.house_layout">
                                <option value="" selected disabled>点击选择</option>
                                <option value="1">主卧 Master room</option>
                                <option value="2">一室一卫 / 一房studio</option>
                                <option value="3">两室一卫</option>
                                <option value="4">两室两卫</option>
                                <option value="5">三室一卫</option>
                                <option value="6">三室两卫</option>
                                <option value="7">其他户型</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">是否复式</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select5"  v-model="data.is_duplex">
                                <option value="0" selected>非复式楼层</option>
                                <option value="1">是复式楼层</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after" v-show="data.is_duplex==1">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">复式楼层</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select6"  v-model="data.duplex_floor" >
                                <option value="" selected disabled>点击选择</option>
                                <option value="2">复式2层</option>
                                <option value="3">复式3层</option>
                                <option value="4">复式4层</option>
                                <option value="5">复式5层</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title" >更多详情</div>
                <div class="weui-cells weui-cells_form" >
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">地毯清洁</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select4" v-model="data.carpet">
                                <option value="" selected disabled>点击选择</option>
                                <option value="0">无需清洁地毯</option>
                                <option value="1">1室地毯清洁</option>
                                <option value="2">2室地毯清洁</option>
                                <option value="3">3室地毯清洁</option>
                                <option value="4">4室地毯清洁</option>
                                <option value="5">5室地毯清洁</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">楼层电梯 </label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select4" v-model="data.floor">
                                <option value="" selected disabled>点击选择</option>
                                <option value="1551412462">住处有电梯 / 住在Ground层</option>
                                <option value="1551412475">无电梯，住1层</option>
                                <option value="1551412486">无电梯，住2层</option>
                                <option value="1551412499">无电梯，住3层</option>
                                <option value="1551412509">无电梯，住4层</option>
                                <option value="1551412525">无电梯，住5层</option>
                                <option value="1551412535">无电梯，住5层以上</option>
                            </select>
                        </div>
                    </div>

                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">能否停车</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select7"  v-model="data.parking">
                                <option value="" selected disabled>点击选择</option>
                                <option value="1551410087">有停车位</option>
                                <option value="1551410093">无停车位</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title">地址详情</div>
                <div class="weui-cells weui-cells_form" >
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">Street</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="如：Unit 2, 9 Hunter St"  v-model="data.address_street">
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_access padding-fix" @click="suburbSelect()">
                        <div class="weui-cell__hd">
                            <label class="weui-label">Suburb</label>
                        </div>
                        <div class="weui-cell__bd" v-if="data.address_suburb==''"> 
                            <p class="placeholder-color">如：Chatswood</p>
                        </div>
                        <div class="weui-cell__bd" v-if="data.address_suburb!=''"> 
                            <p>{{data.address_suburb}}</p>
                        </div>
                        <div class="weui-cell__ft"></div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd"><label class="weui-label">State</label></div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select2" >
                                <option value="NSW" selected>NSW</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell" >
                        <div class="weui-cell__hd"><label class="weui-label">Postcode</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="如：2000"  v-model="data.address_postcode">
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title">留言备注</div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__bd">
                            <textarea class="weui-textarea" placeholder="告诉我们更多需求，以便给您提供更周到的服务" rows="3" v-model="data.msg"></textarea>
                        </div>
                    </div>
                </div>
            <br>
            </div>
        </div>
        <div class="btn-box-fix">
            <div class="slogan" @click="pricePick()">点击查看{{cleanType}}的 <span class="color-orange"><span class="icon-external-link"></span> 收费标准和清洁项目</span></div>
            <div class="btn-container">
                <div class="btn active" @click="submitOrder()">立即下单</div>
            </div>
        </div>
    </div>
    <div v-show="localErrorShow">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__bd">{{localError[0]}}</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
            </div>
        </div>
    </div>
    <transition name="fade">
        <div id="loadingToast" v-show="isSending">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在提交订单</p>
            </div>
        </div>
    </transition>
    <img :src="pixelURL('qingjie','xiadan')" class="hide">
  </div>
</template>

<script>
import qs from 'qs'
import anime from 'animejs';
import Vue from 'vue'

export default {
  name: 'index',
  data () {
    return {
        data:{
            token:0,
            type_id:"1550735948",
            member_name:"",
            member_phone:"",
            address_street:"",
            address_suburb:"",
            address_postcode:"",
            address_state:"NSW",
            address_unit:"",
            service_date:"",
            service_period:"",
            house_type:"",
            house_layout:"",
            carpet:"",
            parking:"",
            msg:"",
            floor:"",
            is_duplex:0,
            duplex_floor:"",
            order_source:"3"
        },
        isSending:false,
        nextStep:false,
        ifSuburb:false,
        ifDatepk:false,
        ifPrice:false,
        localError:[],
        localErrorShow:false,
        rememberTop:0
    }
  },
  computed: {
    cleanType: function () {
      let result = '';
      
      switch (this.data.type_id) {
        case "1550735948":
          result = '大扫除清洁'
          break;
        case "1550735961":
          result = '短租屋清洁'
          break;
        case "1550735971":
          result = '周期清洁'
          break;
        case "1550735962":
          result = '专项清洁'
          break;
        default:
          console.log("2");
      }
      return result;
    },
  },
  methods: {
    goBack: function() {
        if(this.nextStep){
            this.nextStep = false;
            return false;
        }
        if(this.$route.query.back){
            this.$router.go(-1);
        }
        else{
            this.$router.push('/clean-switch');
        }
    },
    dateToday: function(){
        let today = new Date().toISOString().slice(0, 10);
        return today;
    },
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    suburbSelect: function() {
        this.rememberTop = window.scrollY;
        this.ifSuburb=true;
        document.querySelector("html").classList.remove("service-clean-bg");
        document.querySelector("html").classList.add("grey-background");
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    },
    datePick: function() {
        this.rememberTop = window.scrollY;
        this.ifDatepk=true;
        document.querySelector("html").classList.remove("service-clean-bg");
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    },
    datePickClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.add("service-clean-bg");
        this.ifDatepk=false;
    },
    pricePick: function() {
        this.rememberTop = window.scrollY;
        this.ifPrice=true;
        document.querySelector("html").classList.remove("service-clean-bg");
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    },
    priceClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.add("service-clean-bg");
        this.ifPrice=false;
    },

    changeDate: function(theDate) {
        this.data.service_date = theDate;
        this.data.service_date= Vue.filter('moment')(theDate,"YYYY-MM-DD");

        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.add("service-clean-bg");
        this.ifDatepk=false;
    },
    changeSuburb: function(suburb,postcode) {
        this.data.address_suburb = suburb;
        this.data.address_postcode = postcode.toString();
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.remove("grey-background");
        document.querySelector("html").classList.add("service-clean-bg");
        this.ifSuburb=false;
    },
    suburbClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.remove("grey-background");
        document.querySelector("html").classList.add("service-clean-bg");
        this.ifSuburb=false;
    },
    dataLint(name,value){
        let result ="";
        //大扫除
        if(this.data.type_id=="1550735948"){
            if (name == "house_layout"){
                switch (value) {
                case "1":
                    result = "1562650449"
                    break;
                case "2":
                    result = "1562650493"
                    break;
                case "3":
                    result = "1562650659"
                    break;
                case "4":
                    result = "1562650676"
                    break;
                case "5":
                    result = "1562650704"
                    break;
                case "6":
                    result = "1562650721"
                    break;
                case "7":
                    result = "1562654198"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "carpet"){
                switch (value) {
                case "1":
                    result = "1562655269"
                    break;
                case "2":
                    result = "1562655276"
                    break;
                case "3":
                    result = "1562655284"
                    break;
                case "4":
                    result = "1562655289"
                    break;
                case "5":
                    result = "1562655295"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "duplex_floor"){
                switch (value) {
                case "2":
                    result = "1562656442"
                    break;
                case "3":
                    result = "1562656448"
                    break;
                case "4":
                    result = "1562656455"
                    break;
                case "5":
                    result = "1562656462"
                    break;
                default:
                    console.log("5");
                }
            }
        }


        //短租屋
        if(this.data.type_id=="1550735961"){
            if (name == "house_layout"){
                switch (value) {
                case "1":
                    result = "1562660387"
                    break;
                case "2":
                    result = "1562660393"
                    break;
                case "3":
                    result = "1562660401"
                    break;
                case "4":
                    result = "1562660407"
                    break;
                case "5":
                    result = "1562660413"
                    break;
                case "6":
                    result = "1562660422"
                    break;
                case "7":
                    result = "1562660433"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "carpet"){
                switch (value) {
                case "1":
                    result = "1562660697"
                    break;
                case "2":
                    result = "1562660704"
                    break;
                case "3":
                    result = "1562660716"
                    break;
                case "4":
                    result = "1562660722"
                    break;
                case "5":
                    result = "1562660729"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "duplex_floor"){
                switch (value) {
                case "2":
                    result = "1562661091"
                    break;
                case "3":
                    result = "1562661098"
                    break;
                case "4":
                    result = "1562661104"
                    break;
                case "5":
                    result = "1562661109"
                    break;
                default:
                    console.log("5");
                }
            }
        }

        //专项清洁
        if(this.data.type_id=="1550735962"){

            if (name == "carpet"){
                switch (value) {
                case "1":
                    result = "1562662365"
                    break;
                case "2":
                    result = "1562662370"
                    break;
                case "3":
                    result = "1562662375"
                    break;
                case "4":
                    result = "1562662381"
                    break;
                case "5":
                    result = "1562662387"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "duplex_floor"){
                switch (value) {
                case "2":
                    result = "1562662765"
                    break;
                case "3":
                    result = "1562662770"
                    break;
                case "4":
                    result = "1562662774"
                    break;
                case "5":
                    result = "1562662780"
                    break;
                default:
                    console.log("5");
                }
            }
        }

        //周期清洁
        if(this.data.type_id=="1550735971"){
            if (name == "house_layout"){
                switch (value) {
                case "1":
                    result = "1563859625"
                    break;
                case "2":
                    result = "1563859653"
                    break;
                case "3":
                    result = "1563859679"
                    break;
                case "4":
                    result = "1563859705"
                    break;
                case "5":
                    result = "1563859734"
                    break;
                case "6":
                    result = "1563859765"
                    break;
                case "7":
                    result = "1563859801"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "carpet"){
                switch (value) {
                case "1":
                    result = "1563860277"
                    break;
                case "2":
                    result = "1563860293"
                    break;
                case "3":
                    result = "1563860312"
                    break;
                case "4":
                    result = "1563860332"
                    break;
                case "5":
                    result = "1563860375"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "duplex_floor"){
                switch (value) {
                case "2":
                    result = "1563862827"
                    break;
                case "3":
                    result = "1563862848"
                    break;
                case "4":
                    result = "1563862864"
                    break;
                case "5":
                    result = "1563862881"
                    break;
                default:
                    console.log("5");
                }
            }
        }
      return result;
    },
    submitOrder: function() {
        if(!this.nextStep){
            if(this.checkSubmit()){
                this.nextStep=true;
                return false;
            }
        }
        if(this.nextStep){
            if(this.checkSubmitPost()){
                this.submitOrderPost();
            }
        }
    },
    checkSubmit(){
        this.localError = [];
        if (!this.data.type_id) {
            this.localError.push("请选择服务类型");
        }
        if (!this.data.service_date) {
            this.localError.push("请填写服务日期");
        }
        if (!this.data.house_type) {
            this.localError.push("请选择房屋类型");
        }
        if (this.data.type_id!=1550735962 && !this.data.house_layout) {
            this.localError.push("请选择清洁范围");
        }
        if (this.data.is_duplex==1&&!this.data.duplex_floor) {
            this.localError.push("请选择复式楼层");
        }
        if (!this.data.carpet) {
            this.localError.push("请选择地毯清洁需求");
        }
        if (!this.data.parking) {
            this.localError.push("请选择停车位情况");
        }
        if (!this.data.address_street) {
            this.localError.push("请填写 Street 地址信息");
        } else if (this.data.address_street.length < 5) {
            this.localError.push("Street 地址长度过短，请检查是否正确");
        }
        if (!this.data.address_suburb) {
            this.localError.push("请选择地址栏 Suburb");
        }
        if (!this.data.address_postcode) {
            this.localError.push("请填写 Postcode 邮编");
        } else if (this.data.address_postcode.length != 4) {
            this.localError.push("请填写4位数字 Postcode 邮编号码");
        }
        if (!this.localError.length) {
          return true;
        }
        else{
          this.localErrorShow = true;
          return false;
        }
    },
    checkSubmitPost(){
      this.localError = [];
      if (!this.data.member_name) {
          this.localError.push("请填写联系人名");
      }
      if (!this.data.member_phone) {
          this.localError.push("请填写联系人手机号");
      }
      if (this.data.member_phone.length<8 || this.data.member_phone.length>11) {
          this.localError.push("手机号码长度不正确，请检查是否正确");
      }
      if (!this.localError.length) {
        return true;
      }
      else{
        this.localErrorShow = true;
        return false;
      }
    },
    submitOrderPost(){
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.data));

        orderObject.token = 0;

        orderObject.house_layout = this.dataLint("house_layout",orderObject.house_layout);
        orderObject.carpet = this.dataLint("carpet",orderObject.carpet);
        orderObject.duplex_floor = this.dataLint("duplex_floor",orderObject.duplex_floor);

        if(this.data.type_id=="1550735962"){
            //如果是专项清洁，户型改为出车费
            orderObject.house_layout = "1562662349";
        }
        
        this.axios.post(this.apiURL()+'/Order/createOrder', qs.stringify(orderObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.$router.push('/order-detail?id='+response.data.data.order_number+'&type='+that.data.type_id);
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },
  },
  created: function () {
    document.querySelector("html").classList.add("service-clean-bg");
    if(this.data.member_name==""&&localStorage.member_name){
        this.data.member_name = localStorage.member_name;
    }
    if(this.data.member_phone==""&&localStorage.member_phone){
        this.data.member_phone = localStorage.member_phone;
    }
    if(this.$route.query.service){
        let result = "";
        switch (this.$route.query.service) {
          case "dasaochu":
            result = "1550735948";
            break;
          case "zhuanxiang":
            result = "1550735962";
            break;
          case "duanzuwu":
            result = "1550735961";
            break;
          case "zhouqi":
            result = "1550735971";
            break;
          default:
            console.log("订单状态异常");
        }
        this.data.type_id = result;
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("service-clean-bg");
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.main{
    padding:0 10px;
}
.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    background:rgba(255, 255, 255, 0.9);
    z-index:999;
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
    .icon-arrow-left{
        padding-left:12pt;
    }
    .top-title{
        font-size:0.5em;
        line-height:3.2em;
        color:#444;
        vertical-align:top;
        display:inline-block;
        text-align:center;
    }
}

.container{
  padding-bottom:80px;
}

.container /deep/ .weui-label{
    width:90px;
}

.core{
  background:#f6f6f6;
  border-radius:4px;
  h2{
    padding: 14px 14px 0 14px;
    text-align:center;
  }
}

.logo{
  margin:10vh 0 2vh 6vw;
  img{
    width:46%;
  }
}

.title-sub{
  color: #fff;
  font-size: 0.8em;
  text-align: left;
  margin-bottom:5vh;
}
.park-assist{
    text-align:center;
    color:#fe9567;
}

.container /deep/ .weui-cells_checkbox .weui-check:checked+.weui-icon-checked:before{
  color: #fe9567;
}
.prepay-img{
  width:100%;
}

.slogan{
  margin-top:10px;
  margin-bottom:0px;
  font-size:0.9em;
}
</style>



// WEBPACK FOOTER //
// src/pages/cleanEx/clean-index.vue